import dayjs from "dayjs";
import { Modal, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../context/GlobalContext";
import useGet from "../../hooks/common/useGet";
import { API_DAILY_COLLECTIONS } from "../../utils/apis";
import { useToasts } from "../../hooks/common/useToasts";

const { RangePicker } = DatePicker;

export const SyncDailyCollectionsModal = () => {
  const { data, updateData } = useGlobalContext();
  const { openSyncCollection, staffId } = data || {};
  const { loadData, loading, success, error } = useGet();

  const [filters, setFilters] = useState({
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  });

  const handleClose = () => {
    updateData({
      openSyncCollection: false,
      staffId: null,
    });
  };

  useToasts({
    success,
    error,
    redirect: "reload",
    submitting: loading,
    successMessage: "Synced Successfull",
  });

  const handleSync = () => {
    const params: any = {
      start_date: filters.start_date,
      end_date: filters.end_date,
    };

    if (staffId) {
      params.staff_id = staffId;
    }

    loadData({
      api: `${API_DAILY_COLLECTIONS}sync-collections/`,
      params,
    });
  };

  // Track loading from useGet to close modal or show toast
  useEffect(() => {
    if (!loading && success) {
      // success finished
      handleClose();
    }
  }, [loading, success]);

  return (
    <Modal
      open={!!openSyncCollection}
      title="Sync Collection"
      onCancel={handleClose}
      onOk={handleSync}
      okText="Sync"
      confirmLoading={loading}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <label>Select Date Range</label>
        <RangePicker
          value={[dayjs(filters.start_date), dayjs(filters.end_date)]}
          onChange={(dates) =>
            setFilters({
              start_date: dates?.[0]?.format("YYYY-MM-DD")!,
              end_date: dates?.[1]?.format("YYYY-MM-DD")!,
            })
          }
        />
      </div>
    </Modal>
  );
};
